import {
  markGroupParentFullSql,
  markOpportunityFullIfAtCapacitySql,
  reopenGroupParentIfChildOpenSql,
  reopenOpportunityIfBelowCapacitySql,
} from "@shared/helpers/opportunity-occupancy";
import { SqlDatabase } from "remult";

/** Keep is_full in step with occupied seats after a registration change. */
export async function syncOpportunityFullFlagFromSeats(
  opportunity: { id: string; parentOpportunityId?: string | null },
  reopenIfBelowCapacity: boolean,
): Promise<void> {
  const mark = SqlDatabase.getDb().createCommand();
  await mark.execute(
    markOpportunityFullIfAtCapacitySql(mark.param(opportunity.id)),
  );
  if (reopenIfBelowCapacity) {
    const reopen = SqlDatabase.getDb().createCommand();
    await reopen.execute(
      reopenOpportunityIfBelowCapacitySql(reopen.param(opportunity.id)),
    );
  }

  const parentId = await parentOpportunityId(opportunity);
  if (!parentId) return;

  const markParent = SqlDatabase.getDb().createCommand();
  await markParent.execute(markGroupParentFullSql(markParent.param(parentId)));
  if (!reopenIfBelowCapacity) return;

  const reopenParent = SqlDatabase.getDb().createCommand();
  await reopenParent.execute(
    reopenGroupParentIfChildOpenSql(reopenParent.param(parentId)),
  );
}

async function parentOpportunityId(opportunity: {
  id: string;
  parentOpportunityId?: string | null;
}): Promise<string | null> {
  if (opportunity.parentOpportunityId !== undefined) {
    return opportunity.parentOpportunityId;
  }
  const lookup = SqlDatabase.getDb().createCommand();
  const found = await lookup.execute(
    `SELECT parent_opportunity_id FROM opportunity WHERE id = ${lookup.param(opportunity.id)}`,
  );
  const parentId = found.rows[0]?.parent_opportunity_id;
  return typeof parentId === "string" && parentId.length > 0 ? parentId : null;
}
